import { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import usePmSensorAuthId from 'components/hooks/PM/usePmSensorAuthId';
import useRestoreResourceTypeIfNotExists from '../../useRestoreResourceTypeIfNotExists';
import useDefaultResourceType from './useDefaultResourceType';
import { getResourceTypeDependencies } from '../../resource_types';
import useRaWidgetConfigPayload from '../../settings/hooks/useRaWidgetsConfig/useRaWidgetConfigPayload';
import { CONFIG_WIDGETS_NAMES } from '../../settings/hooks/useRaWidgetsConfig/useRaWidgetsConfig';
import { ResourceAllocationFiltersContext } from '../../../state/filters/contexts';
import useResourceAllocationService from 'common/services/resource-allocation.service.versions';
import { useDebounceCallback } from '@react-hook/debounce';

const useFteAllocation = () => {
  const {
    state: { period, filtersPayload, extraPayload, isInitialized }
  } = useContext(ResourceAllocationFiltersContext);
  const raService = useResourceAllocationService();

  const defaultResourceType = useDefaultResourceType();
  const pmSensorAuthId = usePmSensorAuthId();
  const [resourceType, setResourceType] = useState(defaultResourceType);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const widgetConfigPayload = useRaWidgetConfigPayload(
    CONFIG_WIDGETS_NAMES.DONUT_CHART
  );

  useRestoreResourceTypeIfNotExists({
    resourceType,
    restoreFn: () => setResourceType(defaultResourceType)
  });

  const fetchFteAllocation = useDebounceCallback(async () => {
    try {
      const res = await raService.getDonutChart({
        sensor_authorization_id: pmSensorAuthId,
        before: period.before,
        after: period.after,
        type: resourceType.type,
        ...(resourceType.id && { id: resourceType.id }),
        ...(resourceType.extraParams && {
          extraParams: resourceType.extraParams
        }),
        filtersPayload,
        extraPayload,
        limit: widgetConfigPayload.limit
      });

      const resData = _.get(res, 'data', []);
      setData(resData);
    } catch (e) {
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, 500);

  useEffect(() => {
    if (!isInitialized) return;
    setIsLoading(true);
    fetchFteAllocation();
  }, [
    isInitialized,
    period.before,
    period.after,
    filtersPayload,
    ...getResourceTypeDependencies(resourceType)
  ]);

  return {
    data,
    isLoading,
    resourceType,
    setResourceType
  };
};

export default useFteAllocation;
